const SUGGESTED_TIMELINE_ITEM_KIND = 'SUGGESTED_USER';

const SUGGESTED_FEED_REASON_CODES = new Set([
  'suggested_user',
  'looking_for_you',
  'matches_your_search',
]);

function normalizeText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function normalizeReasonCode(value) {
  return normalizeText(value).toLowerCase();
}

function readReasonCodes(item) {
  if (Array.isArray(item?.feedReasonCodes)) {
    return item.feedReasonCodes;
  }
  if (Array.isArray(item?.reasonCodes)) {
    return item.reasonCodes;
  }
  return [];
}

function isSuggestionReasonCode(value) {
  const reasonCode = normalizeReasonCode(value);
  return SUGGESTED_FEED_REASON_CODES.has(reasonCode);
}

export function isSuggestedFeedItem(item) {
  if (!item || typeof item !== 'object') {
    return false;
  }

  if (normalizeText(item.timelineItemKind).toUpperCase() === SUGGESTED_TIMELINE_ITEM_KIND) {
    return true;
  }

  if (normalizeText(item.suggestionKind)) {
    return true;
  }

  return readReasonCodes(item).some(isSuggestionReasonCode);
}
